var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95224 9.96716C6.4208 10.6035 7.18173 10.6035 7.65028 9.96716L12.4483 3.45119C12.7931 2.98285 12.8943 2.28544 12.7069 1.67457C12.5195 1.06369 12.0847 0.666626 11.5974 0.666626L2.00139 0.671717C1.51784 0.671717 1.07928 1.06878 0.891854 1.67966C0.704432 2.29053 0.809388 2.98794 1.1505 3.45628L5.94849 9.97225L5.95224 9.96716Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.7184032322b1e71b2d9e2f3615a2548c.svg";
export { ForwardRef as ReactComponent };